import { CasEntityRHFSelect, CasEntitySelectProps } from 'src/compass/shared/components';

export function RHFRequestTypeSelect(props: CasEntitySelectProps) {
  return CasEntityRHFSelect('Uploads/RequestType/Select', props);
}

